import { createSelector } from 'reselect'

import getDecimalValue from 'utils/get-decimal-value'

import { FETCH_STATUSES } from 'resources'
import constants from './constants'

export const getIsAppInitialized = (state) => state.general.status === constants.INITIALIZED
export const getIsAuthenticatedRoute = ({ general }) => general.isAuthenticatedRoute
export const getIsOpenModal = (state) => state.general.isOpenModal
export const getModalTitle = (state) => state.general.modalTitle
export const getModalMessage = (state) => state.general.modalMessage
export const getButtonLabel = (state) => state.general.buttonLabel
export const getRegion = (state) => state.general.region
export const getIpAddress = (state) => state.general.ipAddress

export const getIsRegionCheckInProgress = ({ general }) => general.regionCheckStatus === FETCH_STATUSES.FETCHING
export const getIsRegionCheckSuccess = ({ general }) => general.regionCheckStatus === FETCH_STATUSES.SUCCESS
export const getIsRegionCheckFailure = ({ general }) => general.regionCheckStatus === FETCH_STATUSES.FAILURE
export const getIsNoInternetError = ({ general }) => !!general.isNoInternetError

export const getRedemptionShareCaption = (state) => state.general.redemptionShareCaption

export const getEnableReferral = (state) => state.general.enableReferral
export const getReferrerBonusLimit = (state) => state.general.referrerBonusLimit
export const getReferralBonusAmount = (state) => state.general.referralBonusAmount
export const getReferralRewardsRatio = (state) => state.general.referralRewardsRatio
export const getReferralRewardsPercentage = createSelector(getReferralRewardsRatio, (rewardsRatio) =>
  Math.round(rewardsRatio * 100),
)
export const getIsSecureConstantsFetched = (state) =>
  state.general.isSecureConstantsFetched === constants.SECURE_CONSTANTS_FETCHED

export const getRedemptionMinAccountAge = (state) => state.general.redemptionMinAccountAge

export const getRedemptionMinAccountBalance = (state) =>
  getDecimalValue(state.general.redemptionMinBalance, Number.MAX_VALUE)

export const getRedemptionOptionsHelpLink = (state) => state.general.redemptionOptionsHelpLink

export const getRedemptionMinRequestInterval = (state) => state.general.redemptionMinRequestInterval

export const getAccountStatusHelpLink = (state) => state.general.accountStatusHelpLink

export const getIntercomUserHashWeb = (state) => state.general.intercomUserHashWeb

export const getPointsMultiplier = ({ general }) => general.pointsMultiplier

export const getIsBitcoinEnabled = ({ general }) => general.enableBitcoin
export const getIsEthereumEnabled = ({ general }) => general.enableEthereum
export const getIsUsdcEnabled = ({ general }) => general.enableUsdc
export const getPolygonLearnMoreUrl = ({ general }) => general.polygonLearnMoreUrl
export const getSharesForRedemptionState = ({ general }) => general.sharesForRedemptionState
export const getSharesRequiredQuestionLabels = ({ general }) => general.sharesRequiredQuestionLabels
export const getSharesHoldProcessExplanation = ({ general }) => general.sharesHoldProcessExplanation
export const getSharesAutoRedeemExplanationLink = ({ general }) => general.sharesAutoRedeemExplanationLink

// TNG index in API 0-6 represents Monday to Sunday. Luxon 1-7 represents Monday to Sunday.
// +1 is added to make the date compatible with the backend
export const getWeeklyPaycheckDay = (state) => state.general.weeklyPaycheckDay + 1

export const getSubscriptionBasicVerifiedIdLimit = ({ general }) => general.subscriptionBasicVerifiedIdLimit
export const getSubscriptionLiteVerifiedIdLimit = ({ general }) => general.subscriptionLiteVerifiedIdLimit
export const getSubscriptionProVerifiedIdLimit = ({ general }) => general.subscriptionProVerifiedIdLimit

export default {
  getIsAppInitialized,
  getIsAuthenticatedRoute,
  getIsOpenModal,
  getModalTitle,
  getModalMessage,
  getButtonLabel,
  getRegion,
  getIsRegionCheckInProgress,
  getIsRegionCheckSuccess,
  getIsRegionCheckFailure,
  getIsNoInternetError,
  getIpAddress,
  getEnableReferral,
  getReferrerBonusLimit,
  getReferralBonusAmount,
  getReferralRewardsRatio,
  getReferralRewardsPercentage,
  getIsSecureConstantsFetched,
  getRedemptionMinAccountAge,
  getRedemptionMinAccountBalance,
  getRedemptionOptionsHelpLink,
  getRedemptionMinRequestInterval,
  getAccountStatusHelpLink,
  getIntercomUserHashWeb,
  getPointsMultiplier,
  getIsBitcoinEnabled,
  getIsEthereumEnabled,
  getIsUsdcEnabled,
  getWeeklyPaycheckDay,
  getSubscriptionBasicVerifiedIdLimit,
  getSubscriptionLiteVerifiedIdLimit,
  getSubscriptionProVerifiedIdLimit,
}
